import {
	usePolicies,
	PolicyEditor,
	DeleteButton,
	VisualizeButton,
	SaveButton,
	PolicyToggle,
	usePolicyEditLogic,
	PolicyViewerHeader,
	DocumentViewer,
	ConfirmModal,
	useConfirmModal,
} from '@practium/features/policy';
import { PoliciesLayout } from '../layouts/PoliciesLayout';
import styles from './PolicyEditPage.module.css';

export const PolicyEditPage = () => {
	const {
		policies,
		filteredPolicies,
		selectedPolicy,
		isLoading,
		handleSearch,
		handleTogglePolicy,
		selectPolicy,
		deletePolicy,
		updatePolicy
	} = usePolicies();

	const { confirm, isOpen, options, handleConfirm, handleCancel } = useConfirmModal();

	const {
		currentPolicy,
		isPreviewMode,
		handlePolicyChange,
		handleSave,
		handleDelete,
		handleVisualize,
		handleToggle,
		handleSelectPolicy,
		handleAddPolicy,
	} = usePolicyEditLogic({
		updatePolicy,
		deletePolicy,
		policies,
		filteredPolicies,
		selectedPolicy,
		selectPolicy,
		handleTogglePolicy,
		confirm,
	});

	const headerContent = (
		<PolicyViewerHeader mode={isPreviewMode ? 'view' : 'edit'}>
			<PolicyToggle
				checked={currentPolicy?.isActive || false}
				onChange={handleToggle}
				disabled={!currentPolicy}
			/>
			<div className={styles.buttonsWrapper}>
				{!isPreviewMode && <DeleteButton onClick={handleDelete}>Excluir</DeleteButton>}
				<VisualizeButton onClick={handleVisualize}>
					{isPreviewMode ? 'Editar' : 'Visualizar'}
				</VisualizeButton>
				<SaveButton onClick={handleSave}>Salvar</SaveButton>
			</div>
		</PolicyViewerHeader>
	);

	return (
		<>
			<PoliciesLayout
				updatingPolicyId={currentPolicy?._id || null}
				policies={filteredPolicies}
				selectedPolicy={currentPolicy}
				isLoading={isLoading}
				onSearch={handleSearch}
				onTogglePolicy={handleTogglePolicy}
				onSelectPolicy={handleSelectPolicy}
				onAddPolicy={handleAddPolicy}
				headerContent={headerContent}
			>
				{isPreviewMode ? (
					<DocumentViewer policy={currentPolicy} />
				) : (
					<PolicyEditor policy={currentPolicy} onChange={handlePolicyChange} />
				)}
			</PoliciesLayout>

			<ConfirmModal
				isOpen={isOpen}
				title={options.title}
				message={options.message}
				confirmText={options.confirmText}
				cancelText={options.cancelText}
				variant={options.variant}
				onConfirm={handleConfirm}
				onCancel={handleCancel}
			/>
		</>
	);
};
